import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../components/buttons';
import { saveMasterTag, getMasterData, getMasterTagDetails } from './actions/ManageTagActions';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { isValidNameWithSpace, renderAutoCompleteSingleSelect, renderColorPicker, renderTextArea, renderTextField } from '../../../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../../../src/actions/utilAction';
import SmallLoader from '../../../../img/small-loader.gif';

class ManageTagModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = ({
      open: true,
      tagId: props.tagId,
      Color: (props.tagObj && props.tagObj.colorCode) || '#ffffff',
      FontColor: (props.tagObj && props.tagObj.fontColorCode) || '#000000',
    });
    this.onColorChange = this.onColorChange.bind(this);
    this.onFontColorChange = this.onFontColorChange.bind(this);
  }

  componentWillMount() {
    this.props.getMasterData();
    if (this.state.tagId) {
      this.props.getMasterTagDetails(this.state.tagId);
    }
    // if (this.props.getMasterData && this.props.getMasterData.userRoleType && this.props.getMasterData.userRoleType.length > 0) {
    //   let userRoleType = [];

    //   this.props.getMasterData.userRoleType.map((obj, index) => {
    //     let newobj = {};
    //     newobj.id = obj.id;
    //     newobj.value = obj.roleTypeName;
    //     userRoleType.push(newobj);
    //     return userRoleType;
    //   });

    //   this.setState({

    //     userRoleType: userRoleType,
    //   });
    // }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };


  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.clearFieldErrorArray();
      this.props.closeDialog();
    }
  };

  handleSave=(formProps) => {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formProps.id = this.state.tagId;   
    formProps['tag'] = formProps.tag.trim();
    formProps['value'] = formProps.tag.trim();    
    formProps['description'] = formProps.description ? formProps.description.trim() : '';
    this.props.saveMasterTag(formProps);
    this.setState({ open: false });
    this.props.clearFieldErrorArray();
    this.props.closeDialog();
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name,
        'id': this.state.tagId || 0,
      };
      this.setState({ isFieldExist: true });
      this.props.checkFieldExistence(postData);
    }
  };

  onColorChange(color){    
    this.setState({ Color: color[0]+color[1]+color[2]+color[3]+color[4]+color[5]+color[6] });
  }

  onFontColorChange(color){
    this.setState({ FontColor: color[0]+color[1]+color[2]+color[3]+color[4]+color[5]+color[6] });
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Saving"/> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.handleSave.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose}/>,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.state.tagId ? 'Edit Tag' : 'Add Tag'}
          modal={false}
          actions={actions}
          open={this.state.open}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" noValidate >
                <div className="row">
                  <div className="col-sm-6 require">
                    <Field
                      autoFocus={true}
                      name="tag"
                      label="Tag Name"
                      maxLength ='50'
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Tag name')}
                      customError={displayCustomError('TAG', this.props.fieldError)}
                      component={renderTextField}
                      normalize ={isValidNameWithSpace}
                      fullWidth={true}
                    />
                  </div>
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="roleTypeID"
                      label="Link To"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.userRoleTypes}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 require">
                    <Field
                      name="colorCode"
                      defaultValue={this.state.Color}
                      floatingLabelText="Color"
                      fullWidth={true}
                      onChange={(color) => this.onColorChange(color)}
                      component={renderColorPicker}/>
                      <span className="bgcolor-circle" style={{ backgroundColor: this.state.Color }}></span>
                  </div>
                  <div className="col-sm-6 ">
                    <Field
                      name="fontColorCode"
                      defaultValue={this.state.FontColor}
                      floatingLabelText="Font Color"
                      fullWidth={true}
                      onChange={(fontColor) => this.onFontColorChange(fontColor)}
                      component={renderColorPicker}/>
                      <span className="bgcolor-circle" style={{ backgroundColor: this.state.FontColor }}></span>
                  </div>
                </div>
                <div className = 'row'>
                  <div className="col-sm-12">
                    <Field
                      name="description"
                      label="Description"
                      maxLength='1000'
                      type="text"
                      // normalize ={isValidNameWithSpace}
                      component={renderTextArea}
                      fullWidth={true}
                    />
                    <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>);
  }
}
const selector = formValueSelector('ManageTagModalForm');

ManageTagModal = reduxForm({
  form: 'ManageTagModalForm',
  validate,
  enableReinitialize: true,
})(ManageTagModal);

function mapStateToProps(state, ownProps) {
  let userRoleTypes = [], initialValueData = null;
  if (ownProps.tagId && state.manage_tag.masterTagDetails) {
    initialValueData = state.manage_tag.masterTagDetails.data || null;
  }
  if (state.manage_tag.master_data) {
    userRoleTypes = state.manage_tag.master_data.userRoleType || [];
  }
  return {
    loading: state.manage_tag.loading,
    description: selector(state, 'description'),
    userRoleTypes: userRoleTypes,
    initialValues: initialValueData,
    fieldError: state.appConfig.fieldError,
  };
}
export default connect(mapStateToProps, { clearFieldErrorArray, checkFieldExistence, saveMasterTag, getMasterData, getMasterTagDetails })(ManageTagModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/manageTags/manage_tag_modal.js